var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",class:{'white': _vm.index % 2 == 0}},[_c('div',{staticClass:"col-9 py"},[_c('strong',{staticClass:"meal-name"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.meal)))]),_vm._v(" "),_c('span',{staticClass:"details"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.ingredient)))])]),_vm._v(" "),_c('div',{staticClass:"col-3 price"},[_vm._v(_vm._s(_vm._f("currency")(_vm.item.price)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b9c214e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/karte/KarteItem.vue
// module id = 67
// module chunks = 0